import { amplitudeABTestIdentify } from "./ab-test-identify"

(function () {
  amplitudeABTestIdentify()
})()
